import * as Yup from 'yup'

export const initialValues = {
    old_password: '',
    new_password: '',
    new_password_confirmation: '',
}

export const validationSchema = Yup.object().shape({
    old_password: Yup.string().required('The old password is required'),
    new_password: Yup.string()
        .required('The password is required')
        .matches(/[a-zA-Z][0-9]/, 'Password must contain letters and numbers.')
        .min(6, 'Password minimum is 6 characters'),
    new_password_confirmation: Yup.string()
        .required('Confirm Password is required')
        .oneOf([Yup.ref('new_password')], 'Your passwords do not match.'),
})
